import { useEffect } from 'react';

import type { UseDublicateClientsEffectsProps } from '@pages/DublicateClients/types';

export const useDublicateClientsEffects = ({
  getDublicateClientsHandler,
  getFiltersHandler,
}: UseDublicateClientsEffectsProps) => {
  useEffect(() => {
    getFiltersHandler();
  }, [getFiltersHandler]);

  useEffect(() => {
    getDublicateClientsHandler();
  }, [getDublicateClientsHandler]);
};
